function communityLocations(locationsData) {
  const $gridContainer = document.getElementById("locationList");
  const $viewAllBtn = document.getElementById("locationsViewAll");
  const $locationFilters = document.querySelectorAll(".js-filter-btn");
  const $locationsFilterBtn = document.getElementById("locationFilter");
  const $locationsSliders = document.querySelectorAll(".js-locations-swiper");

  /**
   * init
   */
  function init() {
    if (window.innerWidth > 1024) {
      populateGrid(locationsData.slice(0, 6));
      $viewAllBtn.style.display = "block";
    } else {
      populateGrid(locationsData);
      $viewAllBtn.style.display = "none";
      swiperSlide();
    }

    addEvents();
  }

  /**
   * add events
   */
  function addEvents() {
    $viewAllBtn.addEventListener("click", () => {
      populateGrid(locationsData);
      $viewAllBtn.style.display = "none";
    });

    $locationFilters.forEach((btn) => {
      btn.addEventListener("click", () => {
        const selectedLocation = btn.textContent.trim();
        const filteredItems = locationsData.filter(
          (item) =>
            item.location.toLowerCase() === selectedLocation.toLowerCase()
        );
        $locationsFilterBtn.querySelector("span").textContent =
          selectedLocation;
        populateGrid(filteredItems);
        $viewAllBtn.style.display = "none";
      });
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        populateGrid(locationsData.slice(0, 6));
        $viewAllBtn.style.display = "block";
      } else {
        populateGrid(locationsData);
        $viewAllBtn.style.display = "none";
      }
    });
  }

  /**
   * create grid item
   * @param {Object} item
   */
  function createGridItem(item) {
    const gridItem = document.createElement("div");
    let html = "";
    gridItem.classList.add("locations__location");
    if (window.innerWidth < 1024) gridItem.classList.add("swiper-slide");

    html = `
      <div class="overflow-hidden relative mb-12 lg:mb-16" style="border-radius: 12px;">
        <img class="w-full" src=${item.image_url} alt="${item.name}" loading="lazy"/>
      </div>
      <div class="lg:flex justify-between">
        <div class="locations__location-content-left basis-3/5">
          <div class="locations__location-name">${item.name}</div>
          <div class="flex">
            <div class="locations__location-product">${item.products}</div>
          </div>
          <div class="locations__location-social">
            <a
              href="${item.social_media_link}"
              target="_blank"
              class="link"
              rel="noreferrer"
              >
                ${item.social_media_handle}
              </a
            >
          </div>
        </div>
        <div class="locations__location-content-right">
          <div class="mt-[30px] lg:mt-0 lg:text-right">${item.location}</div>
        </div>
      </div>
    `;
    gridItem.innerHTML = html;
    return gridItem;
  }

  /**
   * create grid item
   * @param {Array} items
   */
  function populateGrid(items) {
    $gridContainer.innerHTML = "";
    items.forEach((item) => {
      const gridItem = createGridItem(item);
      $gridContainer.appendChild(gridItem);
    });
  }

  /**
   * swiper slide
   */
  function swiperSlide() {
    if (window.innerWidth <= 1024) {
      $locationsSliders.forEach((location) => {
        const swiper = new Swiper(location, {
          slidesPerView: 1,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: ".location-swiper-button-next",
            prevEl: ".location-swiper-button-prev",
          },
        });
      });
    }
  }

  return init();
}
